import { useFormik } from 'formik'
import { send } from 'ms-email/api/send-member-invitation'
import { useState } from 'react'
import { SnackAlert, EmailShare as View } from 'ui-components'
import * as Yup from 'yup'

import { getUserByEmail } from '~map-preview/api/getUserByEmail'
import { useInviteUserToMapByEmail } from '~map-preview/hooks/useInviteUserToMapByEmail'
import { useMap } from '~map-preview/states/map'
import { useCreateMemberInvitedUser } from '~workspace/queries/useCreateMemberInvitedUser'

import { mapSharedEvent } from 'tag-manager/map_shared'

export const EmailShare = () => {
  const { invite } = useInviteUserToMapByEmail()
  const [userExists, setUserExists] = useState(false)
  const [isEmailSent, setIsEmailSent] = useState(false)
  const createMemberInvitedUser = useCreateMemberInvitedUser()
  const map = useMap()

  const checkIfWorkspaceMember = (user) => {
    if (!map || !Object.keys(map).length) return false
    if (!user) return false
    return map.workspace.memberCollection.items.some((member) => {
      return member.user.id === user.id
    })
  }

  const form = useFormik<{ email: string; accessLevel: string }>({
    initialValues: {
      email: '',
      accessLevel: 'guest'
    },
    validationSchema: Yup.object().shape({
      email: Yup.string().email('Invalid email').required('Email is required'),
      accessLevel: Yup.string().oneOf(['member', 'guest'])
    }),
    onSubmit: async (values, helpers) => {
      const { email, accessLevel } = values
      setIsEmailSent(false)
      const user = await getUserByEmail({ email })
      const existingUser = checkIfWorkspaceMember(user)

      setUserExists(existingUser)

      if (!existingUser) {
        const actions = {
          member: async () => {
            await send({ workspace: map.workspace }, [email])
            await createMemberInvitedUser.mutateAsync({
              email,
              workspaceId: map.workspace.id
            })
          },
          guest: async () => {
            await invite(email)
          }
        }

        const events = {
          member: 'member_invite',
          guest: 'guest_invite'
        }

        await actions[accessLevel]()
        mapSharedEvent(events[accessLevel])

        setIsEmailSent(true)
      }

      helpers.resetForm()
    }
  })

  const closeSnack = () => {
    setIsEmailSent(false)
    setUserExists(false)
  }

  return (
    <>
      <View form={form} />
      <SnackAlert
        onClose={closeSnack}
        open={!!isEmailSent}
        severity='success'
      >
        Email sent successfully
      </SnackAlert>
      <SnackAlert
        onClose={closeSnack}
        open={!!userExists}
        severity='warning'
      >
        User already a member
      </SnackAlert>
    </>
  )
}
